import { OuiButtonToggleOption } from 'omnium-ui/button-toggle';
import { OuiSelectOption } from 'omnium-ui/form-field';

export type ModeLogement = 'PROPRIETAIRE' | 'LOCATAIRE' | 'HEBERGE_GRATUITEMENT';

const MODE_LOGEMENT_OPTIONS = [
  { label: 'Propriétaire', value: 'PROPRIETAIRE' },
  { label: 'Locataire', value: 'LOCATAIRE' },
  { label: 'Hébergé(e) à titre gratuit', value: 'HEBERGE_GRATUITEMENT' },
];

export const modeLogementOptionsSelect = MODE_LOGEMENT_OPTIONS as OuiSelectOption<ModeLogement>[];

export const modeLogementOptionsToggle = MODE_LOGEMENT_OPTIONS as OuiButtonToggleOption<ModeLogement>[];
